import { createSlice } from '@reduxjs/toolkit';
import { addMonths, subMonths } from 'date-fns';

export type monthNavigatorStateType = {
  date: string;
};

const initialState: monthNavigatorStateType = {
  date: new Date().toString(),
};

export const monthNavigatorSlice = createSlice({
  name: 'monthNavigator',
  initialState,
  reducers: {
    resetState: (state) => {
      state.date = new Date().toString();
    },

    setPrevMonth: (state) => {
      const date = new Date(state.date);
      const newDate = subMonths(date, 1);
      state.date = newDate.toString();
    },

    setNextMonth: (state) => {
      const date = new Date(state.date);
      const newDate = addMonths(date, 1);
      state.date = newDate.toString();
    },
  },
});
